export default function EditFindingCommentDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  amDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveFindingComment = _handleSaveFindingComment;

  vm.IsValidControl = _IsValidControl;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingCommentDialog);
  }

  function _handleSaveFindingComment() {
    const dfdSave = $q.defer();

    if ($scope.editAMFindingNoteForm.$valid) {
      amDataService.saveFindingComment(vm.findingId, vm.findingCommentId, vm.findingCommentText).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the Finding Note.');
        } else {
          alerts.success('The Finding Note has been saved successfully.');
          $rootScope.$broadcast('refreshAMFindingComments', { findingId: vm.findingId });
          ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingCommentDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }

  function _IsValidControl(ctrl) {
    return ($scope.editAMFindingNoteForm)
      && (($scope.editAMFindingNoteForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

EditFindingCommentDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'amDataService'
];
